<template lang="pug">
include /mixins
+b.product-set-card--mini.relative(
  :class="classes"
)
  +e.icons
    add-to-favorites(
      :id='variant.base.element.id'
      :is-liked="variant.base.element.props.is_favorite"
      @hook:remove="$emit('hook:remove', $event)"
      v-if='is_auth'
    )
      template(#default='{ add, is_added, remove }')
        +b.circle-btn--accent.--clear.--grey.--transparent.BUTTON(
          v-if='is_added'
          @click.prevent='remove'
          :title="_('В избранном')"
        )
          +e.icon.IMG(
            src="/static/img/full-heart.svg"
            :alt='_("full heart")'
          )
        +b.circle-btn--accent.--clear.--grey.--transparent.BUTTON(
          @click.prevent='add'
          :title="_('Добавить в избранное')"
          v-else
        )
          +e.icon.--small.icon-like.SPAN
    modal-trigger(
      v-else
      url='UiElements/NotPermission',
      name='NotPermission',
    )
      template(#default='{ open }')
        +b.circle-btn--accent.--clear.BUTTON(
          :title="parent._('Добавить в избранное')"
          @click.prevent='open'
        )
          +e.icon.icon-like.SPAN
  +e.img-wrap(:class='{ "offset_none": isSaleInfo }')
    +b.tt-picture--size_auto.--size_auto-h.product-set-card__img.PICTURE.relative
      source(
        type="image/webp"
        :srcset="variant.base.element.props.img && variant.base.element.props.img.catalog_preview_webp"
      )
      +e.body.IMG(
        v-if='variant.base.element.props.img && variant.base.element.props.img.catalog_preview'
        :src='variant.base.element.props.img && variant.base.element.props.img.catalog_preview',
        :alt='variant.base.element.props.title',
      )
      +e.body.IMG(
        v-else
        src='https://via.placeholder.com/60x60',
      )
  +e.content
    +e.vendor.ds-caption--size_3xs.--medium.seller-product-name(v-if='variant.base.element.props.seller') {{ variant.base.element.props.seller.props.title }}
    +e.vendor.ds-caption--size_3xs.--medium(v-else) {{ variant.base.element.props.product.props.brand.props.title }}
    +e.title.ds-caption--size_3md.--semibold.A.tt-link--variant_start(
      :href='variant.base.element.props.url'
    ) {{ variant.base.element.props.product.props.title }}
    +b.tt-space_mb--2.flex_1(v-if="variant.base.element.props.product" )
      +b.ds-caption--size_sm.--medium.P(v-html='variant.base.element.props.product.props.short_description')
    //- +e.weight.ds-caption--size_3xs.--medium.P(
    //-   v-if='variant.base.element.props.weight'
    //- ) {{ variant.base.element.props.weight.props.name }}
    +b.tt-space_mt--1
      +b.g-row--appearance_nowrap.--align_center.--space_none
        +b.g-cell.g-cols.tt-space_mr--2(
          style='flex-shrink: 0'
          v-if='variant.base.element.props.weight.props.img || variant.base.element.props.weight.props.color'
        )
          +b.product-weight-color-trigger.--space_none
            +e.color.IMG(
              v-if='variant.base.element.props.weight.props.img'
              :src='variant.base.element.props.weight.props.img'
            )
            +e.color(
              v-else
              :style='{ "--color": variant.base.element.props.weight.props.color }'
            )
        +b.g-cell.g-cols
          +b.ds-caption--size_2xs.--color-relief.--medium.P(v-if='variant.base.element.props.weight.props.color_number') {{ variant.base.element.props.weight.props.color_number }} ({{ variant.base.element.props.weight.props.name }})
          +b.ds-caption--size_2xs.--color-relief.--medium.P(v-else) {{ variant.base.element.props.weight.props.name }}
    +e.art.ds-caption--size_3xs.--light.P(v-if="!isSaleInfo") {{ _('Артикул:') }} &nbsp;
      +b.ds-caption--medium.SPAN {{ variant.base.element.props.vendor_code || "-" }}
    +e.price-wrap
      +e.count.--trancparent
        +b.ds-caption.--size_sm.--medium.P {{ variant.base.quantity }} {{ _('шт') }}
      +e.prices
        //- +e.old-price.ds-caption--size_sm.--semibold.--appearance_line-througt.--color_semigrey.P(
        //-   v-if='Number(variant.base.price) !== Number(variant.base.parameters.calculated_price)'
        //-   v-html='getSplittedHtml(variant.base.price)'
        //- )
        //- +e.current-price.ds-caption--size_sm.--semibold.P(
        //-   v-html='getSplittedHtml(variant.base.parameters.calculated_price)'
        //- )
        +b.g-row--align_end.--justify_end
          template(v-if='Number(variant.base.price) !== Number(variant.base.parameters.calculated_price)')
            +b.g-cell.g-cols--narrow
              +b.tt-cart-discount-block
                +b.tt-space_mr--2
                  +b.ds-caption--size_xs.--medium.--color_text-8.--appearance_right.--appearance_nowrap.--appearance_line-througt.--line-h_xs.SPAN(
                    v-html='getSplittedHtml(variant.base.price)'
                  )
                //- +b.tt-cart-discount-percent
                //-   +b.ds-caption--size_3xs.--bold.--color_white.--line-h_xs.P(
                //-     v-if='variant.base.parameters.calculated_price'
                //-   ) -{{ 25 }}%
            +b.g-cell.g-cols--12
              +b.ds-caption--size_2md.--semibold.--appearance_right.--color_red.P(v-html='getSplittedHtml(variant.base.parameters.calculated_price)')
            +b.g-cell.g-cols--12
              +b.ds-caption--size_xs.--medium.--appearance_right.--color_text-8.P
                ui-currency-converter.ds-caption--appearance_right(
                  :price='variant.base.parameters.calculated_price'
                  :site-currency="current_site_currency"
                  :national-currency="national_currency"
                  :national-currency-symbol="national_currency_symbol"
                )
          template(v-else)
            +b.g-cell.g-cols--12
              +b.ds-caption--size_2md.--semibold.--appearance_right.P(v-html='getSplittedHtml(variant.base.price)')
            +b.g-cell.g-cols--12
              +b.ds-caption--size_xs.--medium.--appearance_right.--color_text-8.P
                ui-currency-converter.ds-caption--appearance_right(
                  :price='variant.base.price'
                  :site-currency="current_site_currency"
                  :national-currency="national_currency"
                  :national-currency-symbol="national_currency_symbol"
                )
</template>

<script>
export default {
  name: 'SalesCartVariantCard',
  props: ['variant', 'max', 'classes', 'isSaleInfo'],
  data() {
    return {
      current_site_currency: window.current_site_currency,
      national_currency: window.national_currency,
      national_currency_symbol: window.national_currency_symbol,
      currency: window.currency,
      is_auth: window.authent,
    }
  },
}
</script>
